module.exports = {
  "/:contentSlug/:pageId": {
    "name": "index-redirect"
  },
  "/:contentSlug/:pageId/performance": {
    "success": {
      "empty state": [
        "HEADER_LOADED",
        "PERFORMANCE_TAB_EMPTY_LOADED"
      ],
      "tables loaded": [
        "HEADER_LOADED",
        "PERFORMANCE_TAB_LOADED"
      ]
    }
  },
  "/:contentSlug/:pageId/optimization": {
    "name": "optimization-redirect"
  },
  "/:contentSlug/:pageId/optimization/:somePath": {
    "success": {
      "keyword": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_KEYWORD_LOADED"
      ],
      "inbound links": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED"
      ],
      "internal links": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_INTERNAL_LINKS_LOADED"
      ],
      "panel": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_PANEL_LOADED"
      ]
    }
  },
  "/:contentSlug/:pageId/testResults": {
    "success": {
      "Personalization expirement with data": [
        "HEADER_LOADED",
        "PERSONALIZATION_LOADED"
      ],
      "Personalization experiment running no data": [
        "HEADER_LOADED",
        "PERSONALIZATION_NO_DATA_LOADED"
      ],
      "Personalization experiment not started": [
        "HEADER_LOADED",
        "PERSONALIZATION_NOT_STARTED_LOADED"
      ],
      "Personalization results with data": [
        "HEADER_LOADED",
        "PERSONALIZATION_RESULTS_LOADED"
      ],
      "Personalization results no data": [
        "HEADER_LOADED",
        "PERSONALIZATION_RESULTS_NO_DATA_LOADED"
      ],
      "Variations loaded": [
        "HEADER_LOADED",
        "VARIANTIONS_LOADED"
      ]
    }
  },
  "/:contentSlug/:pageId/smart-content": {
    "success": {
      "smart content loaded no data": [
        "HEADER_LOADED",
        "SMART_CONTENT_LOADED_NO_DATA"
      ],
      "smart content loaded": [
        "HEADER_LOADED",
        "SMART_CONTENT_LOADED"
      ]
    }
  },
  "/:contentSlug/:pageId/published": {
    "name": "performance-just-published",
    "success": {
      "Published page detail loaded": [
        "HEADER_LOADED",
        "PERFORMANCE_TAB_EMPTY_LOADED"
      ]
    }
  },
  "/:contentSlug/:pageId/scheduled": {
    "name": "performance-just-scheduled",
    "success": {
      "Scheduled page detail loaded": [
        "HEADER_LOADED",
        "PERFORMANCE_TAB_EMPTY_LOADED"
      ]
    }
  },
  "/:contentSlug/optimization/:somePath": {
    "name": "external-page-routes",
    "success": {
      "keyword": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_KEYWORD_LOADED"
      ],
      "inbound links": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED"
      ],
      "internal links": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_INTERNAL_LINKS_LOADED"
      ],
      "panel": [
        "HEADER_LOADED",
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_PANEL_LOADED"
      ]
    }
  }
};